import { mailConversationReadingPaneRouteEntryHandler } from './mailConversationReadingPaneRouteHandler';
import { mailFolderRouteHandler } from './mailFolderRouteHandler';
import { mailItemViewReadingPaneRouteEntryHandler } from './mailItemReadingPaneRouteHandler';
import { RegisterRouteFunction } from 'owa-router';

const CONVERSATION_VIEW_SUB_PATH = ':folderId/id/:conversationId';
const ITEM_VIEW_SUB_PATH = ':folderId/itemId/:itemId';

const EVENT_DETAILS_SUB_PATH = 'event/:eventId/details';
const EVENT_EDIT_SUB_PATH = 'event/:eventId/edit/:scope';

const DETAILS_SPOKE_SUB_PATH = 'spoke/:spokeType/:scope';
const EDIT_SPOKE_SUB_PATH = 'spoke/:spokeType';

const ATTENDEE_CARD_SUB_PATH = 'card/:routeIdType/:routeId/:view';

const FOLDER_SUB_PATH = ':folderId';

export const registerCalendarEventRoutes = (registerRoute: RegisterRouteFunction): void => {
    // For edit and details main screen
    registerRoute(`/${FOLDER_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}`, mailFolderRouteHandler);
    registerRoute(`/${FOLDER_SUB_PATH}/${EVENT_EDIT_SUB_PATH}`, mailFolderRouteHandler);
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );

    // For spokes
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${FOLDER_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}`,
        mailFolderRouteHandler
    );
    registerRoute(
        `/${FOLDER_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}`,
        mailFolderRouteHandler
    );

    // For attendee cards
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${CONVERSATION_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailConversationReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${ITEM_VIEW_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailItemViewReadingPaneRouteEntryHandler
    );
    registerRoute(
        `/${FOLDER_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailFolderRouteHandler
    );
    registerRoute(
        `/${FOLDER_SUB_PATH}/${EVENT_DETAILS_SUB_PATH}/${DETAILS_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailFolderRouteHandler
    );
    registerRoute(
        `/${FOLDER_SUB_PATH}/${EVENT_EDIT_SUB_PATH}/${EDIT_SPOKE_SUB_PATH}/${ATTENDEE_CARD_SUB_PATH}`,
        mailFolderRouteHandler
    );
};
